import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { Box, Button, Form, Link, Stack, Text, TextInput } from 'shell/components';
import { PageContext } from 'pages/ForgotPasswordPage/PageProvider';

const ResetPasswordPage = ({ device, errors, form, handleChange, handleSendForgotPasswordCode }) => {
    const { loading } = useContext(PageContext);
    return (
        <EmailBox device={device}>
            <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                <Text variant={'h6'} weight={'medium'}>
                    Forgot Password
                </Text>
                <Text variant={'p1'} align={'center'}>
                    No need to worry! An email will be sent to you with instructions on how to reset your password.
                </Text>
            </Stack>
            <Form onSubmit={() => handleSendForgotPasswordCode()}>
                <InputStack spacing={6}>
                    <TextInput
                        data-cy={'forgot-password-email-input'}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        label={'Email'}
                        value={form.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        placeholder={'Enter email'}
                        required
                    />
                </InputStack>

                <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                    <Button data-cy={'forgot-password-send-email-button'} loading={loading} type={'submit'}>
                        Send Email
                    </Button>
                </Stack>
                <Stack alignItems={'center'}>
                    <Link to={'/'}>Return to login</Link>
                </Stack>
            </Form>
        </EmailBox>
    );
};

const EmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default ResetPasswordPage;
